module.exports = __webpack_public_path__ + "img/ch15_03_draft1 (1).de238696.png";